import { createWebHistory, createRouter } from "vue-router";
import CheckoutComponent from "@/components/Payment/Checkout.vue";
import PaymentCompleted from "@/components/Payment/PaymentCompleted.vue";
import PayPalCapture from "@/views/PayPalCapture.vue";
import PayPalCardPurchase from "@/components/Payment/PayPal/PayPalCardPurchase.vue";
import StripePaymentStatusRedirect from "@/components/Payment/Stripe/StripePaymentStatusRedirect.vue";

const routes = [
  {
    path: "/checkout",
    name: "Checkout",
    component: CheckoutComponent,
  },
  {
    path: "/checkout/paypal_card",
    name: "PayPalCardPurchase",
    component: PayPalCardPurchase,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/payment/completed",
    name: "PaymentCompleted",
    component: PaymentCompleted,
  },
  {
    path: "/paypal/capture/:idempotence",
    name: "PayPalCapture",
    component: PayPalCapture,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/stripe/redirect",
    name: "StripedRedirect",
    component: StripePaymentStatusRedirect,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  next();
});

const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
